module.exports = __webpack_public_path__ + "static/img/logo-white.7d12e244.png";